import React, { useEffect, useRef } from 'react';

import { logout } from '@adsk/acs-sc-web-platform-api';
import { clearNetworkCache } from '@adsk/alloy-helpers';

import IdleTimerManager, {
  IdleTimerManagerOptions,
} from './core/idle-timer-manager';

export type IdleTimerProps = Pick<IdleTimerManagerOptions, 'timeoutMs'>;

export const IdleTimer: React.FC<IdleTimerProps> = ({ timeoutMs }) => {
  const managerRef = useRef<IdleTimerManager | null>(null);

  useEffect(() => {
    managerRef.current = new IdleTimerManager({
      timeoutMs,
      onIdle: () => {
        clearNetworkCache();
        logout();
      },
    });

    managerRef.current.start();

    return () => {
      managerRef.current?.stop();
    };
  }, [timeoutMs]);

  return null;
};
